<template>
    <wrap ref="wrap" :title="title">
        <c-table
                class="table"
                v-for="(week, index) in data"
                :key="'week' + index"
                :head="head"
                :body="week.body">
        </c-table>
    </wrap>
</template>

<script>
  import Wrap from './wrap';
  import CTable from './table';
  import mixin from './mixin';

  export default {
    name: "QC34",
    mixins: [mixin],
    computed: {
      head () {
        return this.data.head || [
          {label: '交易日期', value: 'time'},
          {label: '注单数', value: 'number'},
          {label: '下注金额', value: 'money'},
          {label: '退水后结果', value: 'res'},
          {label: '实际结果', value: 'actual'},
        ];
      },
      body () {
        return this.data.body || [
          {
            time: ['06-24', '周一'],
            number: 0,
            money: 0,
            res: 0,
            actual: 0,
          },
          {
            time: ['06-24', '周一'],
            number: 0,
            money: 0,
            res: 0,
            actual: 0,
          }
        ]
      }
    },
    components: {Wrap, CTable},
  }
</script>

<style lang="stylus" scoped>
    .table + .table {
        margin-top 15px
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC34.vue